import React from 'react'
import { Modal, Form, InputNumber } from 'antd'

interface TrialExtensionModalProps {
    open: boolean
    merchantName?: string
    onCancel: () => void
    onSubmit: (values: { duration: number }) => void
}

export const TrialExtensionModal: React.FC<TrialExtensionModalProps> = ({
    open,
    merchantName,
    onCancel,
    onSubmit
}) => {
    const [form] = Form.useForm()

    const handleOk = () => {
        form.validateFields().then(values => {
            onSubmit(values)
            form.resetFields()
        })
    }

    return (
        <Modal
            title={`Extend Trial for ${merchantName || 'Merchant'}`}
            open={open}
            onOk={handleOk}
            onCancel={onCancel}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    label="Extension Duration (Days)"
                    name="duration"
                    rules={[{ required: true, message: 'Please enter duration' }]}
                    initialValue={7}
                    help="Maximum extension is 30 days"
                >
                    <InputNumber min={1} max={30} style={{ width: '100%' }} />
                </Form.Item>
            </Form>
        </Modal>
    )
}
